import angular from "angular";
import { pipe, prop, times } from "ramda";
import { filters as filtersStore } from "ticketbuyer/time_slots/store";
import { selectOptions } from "./utils";

angular.module("ticketco/common/time_slots").component("timeSlots", {
  templateUrl: function ($attrs) {
    var template = $attrs.templateUrl || "timeSlotsComponent.html";
    return template;
  },
  bindings: {
    entityId: "@",
    slots: "<",
    capacities: "<",
    selected: "<",
    onSelectItemType: "&",
    canAdd: "<",
    onApplyPromocode: "&",
    filter: "<",
  },
  controller: function controller(
    HelpersService,
    TimeSlotsModel,
    TimeSlotsPersistance
  ) {
    var self = this;

    self.$onInit = function onInit() {
      self.selectedSlot = undefined;
      self.selectedCapacity = {};
      TimeSlotsModel.initialize({
        capacities: self.capacities,
        slots: self.slots,
        filters: self.filter,
      }).getTimeSlots(function (slots) {
        self.timeSlots = slots;
      });
      filtersStore.set(self.filter ?? {});
    };

    self.$onChanges = function onChanges(changesObj) {
      if (!changesObj.selected || !changesObj.selected.currentValue) {
        return;
      }
      var capacity;
      var selected = changesObj.selected.currentValue;
      capacity = pipe(
        tc.util.findById(selected.slotId),
        prop("capacities"),
        tc.util.findById(selected.capacityId)
      )(self.timeSlots);
      self.showItemTypes(capacity, selected.slotId);
    };

    self.applyPromocode = function (promoCode) {
      TimeSlotsPersistance.applyPromocode(self.entityId, promoCode)
        .then(function (res) {
          TimeSlotsModel.replaceSlots(res.slots).getTimeSlots(function (slots) {
            self.timeSlots = slots;
          });

          if (res.discount && res.discount.description) {
            self.promoteDiscountDescription = res.discount.description;
          }

          self.onApplyPromocode({
            $promoCode: promoCode,
          });
          HelpersService.showNotification(
            "success",
            window.TC_LABELS.DISCOUNTS_PROMOCODE_APPLIED
          )();
        })
        .catch(function onError(res) {
          HelpersService.showNotification("error", res.data.message)();
        });
    };

    self.onChangeFilter = function onChangeFilter(filter) {
      let pageHref = new URL(window.location.href);

      TimeSlotsModel.filterSlots(filter).getTimeSlots(function (slots) {
        self.timeSlots = slots;
      });

      if (filter.time == "00" || filter.time > self.getMinSlotTime()) {
        pageHref.searchParams.set("start_time", filter.time);
        filtersStore.update((prevFilter) => ({
          ...prevFilter,
          time: filter.time,
        }));
      } else {
        pageHref.searchParams.delete("start_time");
        filtersStore.update(({ time, ...prevFilter }) => ({
          ...prevFilter,
        }));
      }
      if (Number(filter.amount) > 1) {
        pageHref.searchParams.set("group_size", filter.amount);
        filtersStore.update((prevFilter) => ({
          ...prevFilter,
          amount: filter.amount,
        }));
      } else {
        pageHref.searchParams.delete("group_size");
        filtersStore.update(({ amount, ...prevFilter }) => ({
          ...prevFilter,
        }));
      }

      history.replaceState(filter, "title 3", pageHref.toString());
    };

    self.getSlotCapacityItemTypes = function getSlotCapacityItemTypes(
      capacity
    ) {
      var itemTypes = capacity.item_types || [];
      return itemTypes;
    };

    self.showItemTypes = function showItemTypes(capacity, slotId) {
      self.selectedCapacity = capacity;
      self.selectedSlot = slotId;
    };

    self.toggleCapacity = function showItemTypes(capacity, slot) {
      if (self.selectedCapacity.coordinates === capacity.coordinates) {
        self.showItemTypes({}, undefined);
      } else {
        self.showItemTypes(capacity, slot.id);
      }
    };

    self.selectItemType = function selectItemType(itemType) {
      self.onSelectItemType({
        $itemType: itemType,
      });
    };

    self.guid = tc.util.guid;

    self.selectOptions = selectOptions;

    self.range = function (max) {
      return times(function (i) {
        return i;
      }, max + 1);
    };

    self.min = Math.min;
    self.floor = Math.floor;
    self.addLeadingZero = tc.util.addLeadingZero;
    self.getMaxCapacity = function () {
      return TimeSlotsModel.getMaxCapacity();
    };

    self.getMinSlotTime = function () {
      return TimeSlotsModel.getMinSlotTime();
    };

    self.getMaxSlotTime = function () {
      return TimeSlotsModel.getMaxSlotTime();
    };

    self.tooltipDiscountCssClass = ({ retail_price, actual_price }) =>
      retail_price !== actual_price ? "" : "hidden";
  },
});
